export default "__VITE_ASSET__a89fc21d__"